import { Record, Map } from 'immutable';
import { actionTypes, pagingActions, fetchSiteListActions, fetchProgramsBySiteListActions } from './site-list.actions';
import * as api from '../../../api';
import { authActions } from '../../../auth';
import { pagingDataUtilities } from '../../../common';
import { Err } from '../../../err';

export const SitesState = Record({
  selectedSiteId: null,
  programLists: Map({}),
  isFetchingMultiPageSites: false,
  pagingData: pagingDataUtilities.PagingState({}),
  siteListState: api.ApiCallState({}),
  selectedProgramId: null
});

// Backwards-compatible alias: this state Record was renamed from SiteListState to
// SitesState; some modules/tests still reference the original name.
export const SiteListState = SitesState;

export const siteListReducer = (initialState = new SitesState(), action) => {
  var state = initialState.set('pagingData',
    pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

  const sessionActions = [authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS];
  const invalidateActions = pagingActions.allTypes.concat(sessionActions);
  state = state.set('siteListState',
    api.apiCallReducer(state.get('siteListState'), action, fetchSiteListActions, invalidateActions));

  if(action.siteId) {
    state = state.setIn(['programLists', action.siteId],
      api.apiCallReducer(state.getIn(['programLists', action.siteId]), action, fetchProgramsBySiteListActions, sessionActions));
  }

  switch (action.type) {
    case actionTypes.CHANGE_SELECTED_SITE:
      return state.set('selectedSiteId', action.siteId)
                  .set('selectedProgramId', null);
    case actionTypes.CHANGE_SELECTED_PROGRAM:
      return state.set('selectedProgramId', action.programId);
    case actionTypes.FETCH_COMPLETE_SITE_LIST_BEGIN:
      return state.set('isFetchingMultiPageSites', true);
    case actionTypes.FETCH_COMPLETE_SITE_LIST_FAILURE:
      return state.set('isFetchingMultiPageSites', false)
                  .setIn(['siteListState', 'err'], new Err(action.err));
    case actionTypes.FETCH_COMPLETE_SITE_LIST_SUCCESS:
      return state.set('isFetchingMultiPageSites', false)
                  .setIn(['siteListState', 'isValid'], false);
    case actionTypes.ADD_ALL_SITES_TO_LIST:
      return state.setIn(['siteListState', 'data'], action.data);
    case actionTypes.SET_SELECTED_SITE:
      return state.setIn(['create', 'currentSelectedSite'], action.siteId)
                  .setIn(['create', 'currentSelectedProgram'], "");
    case actionTypes.SET_SELECTED_PROGRAM:
      return state.setIn(['create', 'currentSelectedProgram'], action.programId);
    case actionTypes.CLEAR_SELECTED_SITE_PROGRAM:
      return state.set('selectedSiteId', null)
                  .set('selectedProgramId', null);
    default:
      return state;
  }
}
